import { COMPANIES_CONTENT, type CompanyErrorKey } from '../../content/sections/companies.js';
import { ApiError } from '../../lib/http.js';

/* Classifica o erro num código estável — o texto mora só no catálogo bilíngue
   (`companies-modals.ts`). 409 grace_expired é autoritativo do servidor → orienta o
   operador à emissão manual. Mapeado via `switch` para chaves em camelCase — não dá para
   indexar um `Record` com a chave snake_case do `ApiErrorCode` sem violar
   `useNamingConvention` no catálogo. */
function companyErrorKey(err: unknown): CompanyErrorKey {
  if (err instanceof ApiError) {
    switch (err.code) {
      case 'not_found':
        return 'notFound';
      case 'not_blocked':
        return 'notBlocked';
      case 'owner_not_found':
        return 'ownerNotFound';
      case 'invalid_format':
        return 'invalidFormat';
      case 'public_blocked':
        return 'publicBlocked';
      case 'slug_taken':
        return 'slugTaken';
      case 'invalid_logo':
        return 'invalidLogo';
      case 'logo_too_large':
        return 'logoTooLarge';
      case 'invalid_slug':
        return 'invalidSlug';
      case 'unauthorized':
        return 'unauthorized';
      case 'plan_key_taken':
        return 'planKeyTaken';
      case 'grace_expired':
        return 'graceExpired';
      case 'network':
        return 'network';
      default:
        return 'default';
    }
  }
  return 'unexpected';
}

/**
 * Mensagem traduzida para erros de operação em empresas (block/unblock + create).
 *
 * O parâmetro `errors` é o mapa do locale corrente (`useCompaniesContent().errors`); o default
 * pt-BR existe para chamadores fora de componente (testes unitários, scripts) — nenhum dos dois
 * lados guarda o texto do outro idioma.
 */
export function companyErrorMessage(
  err: unknown,
  errors: Readonly<Record<CompanyErrorKey, string>> = COMPANIES_CONTENT['pt-BR'].errors,
): string {
  return errors[companyErrorKey(err)];
}
